// extracted by mini-css-extract-plugin
module.exports = {"errorpage__wrapper":"errorPage_errorpage__wrapper__9KeGQ"};